import api from "app/lib/api";
import endpoints from "static/endpoints";

export const getPatientComplianceAnalytic = async ({
  yearlyFilter,
  accountFilter,
}) => {
  let url = endpoints.dashboard.patientComplianceAnalytic;
  let queryParams = [];

  if (yearlyFilter)
    queryParams.push(`yearlyFilter=${encodeURIComponent(yearlyFilter)}`);
  if (accountFilter)
    queryParams.push(`accountFilter=${encodeURIComponent(accountFilter)}`);

  // Join query params with '&' and add to the URL if there are any params
  if (queryParams.length > 0) {
    url += `?${queryParams.join("&")}`;
  }

  const { data } = await api.get(url.toString());
  return data;
};
